import { render, staticRenderFns } from "./txList.vue?vue&type=template&id=12e4a976&scoped=true&"
import script from "./txList.vue?vue&type=script&lang=js&"
export * from "./txList.vue?vue&type=script&lang=js&"
import style0 from "./txList.vue?vue&type=style&index=0&id=12e4a976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4a976",
  null
  
)

component.options.__file = "txList.vue"
export default component.exports